export default "__VITE_ASSET__BvxjknlZ__"